/**
 * Resolve an array of values into a classname string
 */
export const classNames = (...args) => {
    return args
        .reduce((acc, cur) => {
        if (Array.isArray(cur)) {
            const className = classNames(...cur);
            if (!className)
                return acc;
            return `${acc} ${className}`;
        }
        if (cur)
            return `${acc} ${cur}`;
        return acc;
    }, "")
        .trim();
};
const applyClassName = (passedClassName, value, options) => {
    const { base, excludeValueFromClassName } = options || {};
    const className = typeof passedClassName === "string" ? passedClassName : passedClassName(value);
    if ((value === true && base) || excludeValueFromClassName)
        return className;
    // CSS should be turned on/off for non base viewport with mobile first approach
    if (value === true && !base)
        return `${className}-true`;
    if (value === false && !base)
        return `${className}-false`;
    if (value !== undefined)
        return `${className}-${value}`;
    return null;
};
export const responsiveClassNames = (s, className, value, options) => {
    if (typeof value !== "object") {
        const staticClassName = applyClassName(className, value, {
            base: true,
            excludeValueFromClassName: options?.excludeValueFromClassName,
        });
        return staticClassName ? [s[staticClassName]] : [];
    }
    return Object.keys(value).reduce((acc, viewport) => {
        const base = viewport === "s";
        const viewportClassName = applyClassName(className, value[viewport], {
            base,
            excludeValueFromClassName: options?.excludeValueFromClassName,
        });
        const suffix = base ? "" : `--${viewport}`;
        return [...acc, s[`${viewportClassName}${suffix}`]];
    }, []);
};
export const responsiveVariables = (variableName, value) => {
    if (value === undefined)
        return {};
    if (typeof value !== "object")
        return { [`${variableName}-s`]: value };
    return Object.keys(value).reduce((acc, key) => {
        const viewportValue = value[key];
        if (viewportValue === undefined)
            return acc;
        if (viewportValue === false)
            return acc;
        return {
            ...acc,
            [`${variableName}-${key}`]: viewportValue,
        };
    }, {});
};
const isResponsive = (prop) => {
    if (prop === null)
        return false;
    return typeof prop === "object" && prop !== null && "s" in prop;
};
export const responsivePropDependency = (prop, resolver) => {
    if (!isResponsive(prop))
        return resolver(prop, "s");
    const keys = Object.keys(prop);
    return keys.reduce((acc, viewport) => {
        const viewportValue = prop[viewport];
        if (viewportValue === undefined || viewportValue === null)
            return acc;
        return { ...acc, [viewport]: resolver(viewportValue, viewport) };
    }, {});
};
